import styles from './computer-equipment.module.scss';
import { useCourseGetRequestHook } from 'libs/webkua-lib/src/lib/requestUtils';
import WebkuaTable from '../../../webkua-table/webkua-table';
import { CreateHeaders, HeaderSizeEnum,textHeader } from '@frontend-workspace/react-shared-lib';
import { IComputer } from './../../../_models/computer';
import ComputerEquipmentSkeleton from './computer-equipment-skeleton';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ComputerEquipmentProps { }

export function ComputerEquipment(props: ComputerEquipmentProps) {
  const { t } = useTranslation();
  const { data: computers, isLoading, getData: getComputers }: { data: IComputer[], isLoading: boolean, getData: () => void } = useCourseGetRequestHook(`resource/computers`, []);

  return (<>
    {isLoading ? <ComputerEquipmentSkeleton /> :
      <WebkuaTable
        data={computers}
        headers={CreateHeaders([
          textHeader("name", t('standard.name'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("type", t('standard.type'), HeaderSizeEnum.LARGE),
          textHeader("serialNumber", t('computerEquipment.serialNumber'), HeaderSizeEnum.LARGE)
        ])}
      />}
  </>);
}

export default ComputerEquipment;
